// mock 層簽發的假 JWT(mock GetToken 回應/全 mock 模式的 dev session 共用)。
// hybrid 模式以此識別「全 mock 時期殘留的 session」:假 token 打真後端必 401,
// 只逛 mock 模組時假身分還會一直掛著,所以 hydrate 時要拒絕還原(見 sessionStore)。
export const MOCK_JWT_TOKEN = "mock-jwt-token";
